<template>
  <main>
    <PublicNavigation :showForm="showForm" />
    <!-- Main header -->
    <section class="main-header">
      <div class="container d-flex align-items-center">
        <h1>The best way to find <span>your dream job</span></h1>
        <form
          @submit.prevent
          class="form-inline d-flex align-items-center justify-content-between base-search"
        >
          <div class="col-1-left">
            <v-select
              v-model="keywords"
              placeholder="Competencies"
              label="name"
              :options="getCompetencesFilterList"
              :reduce="competence => competence"
              :clearable="true"
              multiple
            >
              <template v-slot:no-options="{ search, searching }">
                <template v-if="searching && search.length >= 3">
                  No results found for <em>{{ search }}</em
                  >.
                </template>
                <div style="opacity: 0.5" v-else>Please type at least 3 characters</div>
              </template>
            </v-select>
            <div class="form-group">
              <select
                v-model="employment_type"
                class="form-control new-control"
                id="Employment-type"
              >
                <option value="3">All types of employments</option>
                <option value="1">Regular employment</option>
                <option value="2">Self-employment / Freelancing</option>
              </select>
              <label class="sr-only" for="Employment-type">Employment</label>
              <i style="font-size: 11;" class="fas fa-chevron-down"></i>
            </div>
          </div>

          <div class="col-2-middle">
            <v-select
              @search="fetchOptions"
              v-model="sendLocation"
              class="mr-1 w-100"
              label="name"
              placeholder="Location"
              aria-label="location"
              aria-describedby="location-input"
              :options="[...locationsOptions]"
              :reduce="location => location"
              :clearable="false"
              multiple
            >
              <template v-slot:no-options>
                <div style="opacity: 0.5">Please type at least 3 characters</div>
              </template>
            </v-select>
            <div class="form-group">
              <button @click="searchJob(1)" class="btn btn-secondary">Search Jobs</button>
            </div>
          </div>
        </form>
      </div>
    </section>
    <!-- Main header end -->

    <section class="latest-ads">
      <div class="container">
        <div class="row">
          <!-- Left Col -->
          <div class="col-md-12" style="position: relative;">
            <Spinner :isLoading="isLoading" />
            <h2>AVAILABLE JOBS</h2>
            <!-- Single Job Post -->
            <SingleJobAd v-for="jobAd in jobAds" :key="jobAd.id" :jobAd="jobAd" />
            <!-- End Single Job Post -->
          </div>
          <!-- End Left Col -->
        </div>
        <span v-if="totalPages > 1" class="d-flex bottom-controls">
          <div class="mx-auto">
            <Pagination
              v-show="!isLoading"
              :currentPage="currentPage"
              :totalPages="totalPages"
              @nextPage="nextPage"
              @prevPage="previousPage"
              @selectPageByNumber="setPageByNumber"
              @firstPage="setToFirstPage"
              @lastPage="setToLastPage"
              @keyup="keymonitor"
            ></Pagination>
          </div>
        </span>
      </div>
    </section>
    <!-- Job Ads End -->
    <!-- Middle Orange Section -->
    <section class="mid-section">
      <div class="container">
        <h2>Helping you on your journey to success</h2>
        <p>
          Jobshark is not a typical job portal – we are IT experts ourselves and offer a more
          personal service for jobseekers looking to find their next opportunity. Thanks to our
          professional connections and disruptive business model, we’re constantly updating our
          database of openings from leading IT employers – some of which aren’t even actively
          advertising roles.
        </p>
        <p>That’s what makes us different, and that’s what makes your job search go further.</p>
        <div class="d-flex justify-content-around mobile-wrap">
          <div class="text-box d-flex" @click="showFormEvent('candidate')">
            <img src="../../../public/img/homepage/icon-user.png" alt="user" />
            <div class="text">
              <h3>REGISTER PROFILE</h3>
              <p>
                It all starts with your story. Register your profile with us and we’ll start
                matching you right away.
              </p>
            </div>
            <span><i class="fas fa-angle-double-right"></i></span>
          </div>
        </div>
      </div>
    </section>
    <!-- End of orange section -->
    <!-- Footer -->
    <Footer />
    <!-- End footer -->

    <!--  <CustomMainModal @close="showModal = false" v-show="showModal">
      <template v-slot:header>
        <h5>{{ modalTitle }}</h5>
      </template>
      <Signin
        v-if="showLogin"
        @go-to-register="openModal"
        @go-to-reset-password="openModal"
      ></Signin>
      <Register
        v-if="showRegister"
        @go-to-login="openModal"
        @close="showModal = false"
        @emailVerification="(openEmailVerification = true), (showRegister = false)"
      ></Register>
      <ResetPassword v-if="showResetPassword" @close="showModal = false"></ResetPassword>
      <VerificationCode
        v-if="openEmailVerification"
        @prevStep="(showRegister = true), (openEmailVerification = false)"
      ></VerificationCode>
    </CustomMainModal> -->
  </main>
</template>

<script>
import axios from 'axios';
import { mapGetters, mapActions } from 'vuex';

/* import CustomMainModal from '@/components/Modals/CustomMainModal';
import Signin from '@/components/Signin/Signin';
import Register from '@/components/Register/Register';
import ResetPassword from '@/components/ResetPassword/ResetPassword';
import VerificationCode from '@/components/SearchJob/VerificationCode'; */
/* import FilePreview from '@/components/Home/FilePreview'; */
import PublicNavigation from '@/components/Navigations/PublicNavigation';
import Pagination from '@/components/Navigations/Pagination';
import Footer from '@/components/Navigations/PublicFooter';
import SingleJobAd from './SearchJobItem.vue';
import CallToAction from '@/components/common/CallToAction';
import titleMixin from '../../mixins/titleMixin';
import { errorService } from '../../services/errorService';
import Spinner from '../../components/common/LoadingSpinner/Spinner.vue';

export default {
  mixins: [titleMixin],
  title() {
    return 'Find IT Jobs from Leading Tech Companies | Jobshark';
  },
  description() {
    return 'Search among our open positions to find your next dream job in the IT space. We mediate employment and freelancing opportunities for leading tech companies.';
  },
  canonicalLink() {
    return 'https://jobshark.eu/search-jobs';
  },
  components: {
    CallToAction,
    SingleJobAd,
    Spinner,
    /*  CustomMainModal,
    Signin,
    Register,
    ResetPassword,
    VerificationCode, */
    PublicNavigation,
    Pagination,
    Footer,
    /*  FilePreview, */
  },
  data: () => ({
    showForm: {
      formType: '',
      count: 0,
    },
    employersList: [],
    employment_type: 3,
    modalTitle: '',
    showModal: false,
    showResetPassword: false,
    showLogin: false,
    showRegister: false,
    openEmailVerification: false,
    keywords: [],
    jobAds: [],
    employers: [],
    locations: [],
    locationsOptions: [],
    sendLocation: [],
    currentPage: 1,
    totalPages: 0,
    isLoading: true,
  }),
  methods: {
    showFormEvent(type) {
      this.showForm.formType = type;
      this.showForm.count++;
    },
    /*  openModal(e) {
      this.showModal = true;

      if (e.target.id == 'login-btn') {
        this.modalTitle = 'Sign In';
        this.showLogin = true;
        this.showRegister = false;
        this.showResetPassword = false;
      } else if (e.target.id == 'register-btn') {
        this.modalTitle = 'Register';
        this.showLogin = false;
        this.showResetPassword = false;
        this.showRegister = true;
      } else if (e.target.id == 'register-link') {
        this.modalTitle = 'Register';
        this.showRegister = true;
        this.showLogin = false;
        this.showResetPassword = false;
      } else if (e.target.id == 'forgotten-password') {
        this.modalTitle = 'Reset Password';
        this.showRegister = false;
        this.showLogin = false;
        this.showResetPassword = true;
      } else if (e.target.id == 'already-have-account') {
        this.modalTitle = 'Sign In';
        this.showLogin = true;
        this.showRegister = false;
        this.showResetPassword = false;
      }
    }, */
    ...mapActions([
      'fetchAllJobResults',
      'retrieveEmployersDropdownCandidate',
      'retrieveCompetencesList',
      'searchLocationByName',
    ]),
    onEmployerSearch(search, loading) {
      if (search.length >= 3) {
        loading(true);
        this.getEmployers();
        /* this.competencesOptions = this.getCompetencesFilterList; */
      }

      loading(false);
    },
    fetchOptions(search, loading) {
      if (search.length < 3) {
        this.locationsOptions = [];
      }

      if (search.length >= 3) {
        loading(true);

        this.searchLocationByName(search)
          .then(response => {
            const citiesList = response.data.cities;
            const countriesList = response.data.countries;
            const concatedLists = [].concat(countriesList, citiesList);
            this.locationsOptions = concatedLists;
            loading(false);
          })
          .catch(err => {
            loading(false);
            this.$toasted.error(errorService(err), {
              theme: 'bubble',
              icon: 'fa-times-circle',
              position: 'bottom-right',
              duration: 8000,
            });
          });
      }
    },
    nextPage() {
      if (this.currentPage >= 1) {
        this.currentPage++;
        this.searchJob(this.currentPage);
      }
    },
    previousPage() {
      if (this.currentPage > 1) {
        --this.currentPage;
        this.searchJob(this.currentPage);
      } else {
        this.currentPage = 1;
      }
    },
    setToFirstPage() {
      this.currentPage = 1;
      this.searchJob(this.currentPage);
    },
    setToLastPage(lastPage) {
      this.currentPage = lastPage;
      this.searchJob(this.currentPage);
    },
    setPageByNumber(pageNumber) {
      if (pageNumber > this.totalPages || pageNumber < 1) return;
      this.currentPage = pageNumber;
      this.searchJob(this.currentPage);
    },

    keymonitor(event) {
      // who caused it? "event.target.id"
      // console.log('keyup from id: ' + event.target.id);

      // what was pressed?
      let keyMessage = event.key || String.fromCharCode(event.keyCode);

      /* if (event.shiftKey) {
        keyMessage += 'Shift+';
      } */

      if (keyMessage == 'ArrowRight') {
        this.nextPage();
      }

      if (keyMessage == 'ArrowLeft') {
        this.previousPage();
      }
    },
    getEmployers() {
      axios(`${process.env.VUE_APP_API_URL}/externalpages/employers`, {
        method: 'get',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
        },
      })
        .then(res => {
          this.employersList = res.data;
        })
        .catch(err => {
          console.log(err);
        });
    },
    searchJob(currentPage) {
      this.isLoading = true;
      const temp = this.sendLocation.map(location => location.id);
      let empl_type = null;
      if (Number(this.employment_type) !== 3) {
        empl_type = this.employment_type;
      }
      axios(`${process.env.VUE_APP_API_URL}/externalpages/search`, {
        method: 'post',
        data: {
          page: currentPage,
          count: 10,
          competences: this.flattenCompetences(this.keywords),
          employment_type: empl_type,
          locations: temp,
          comstream: false,
        },
        headers: {
          Authorization: `Bearer ${localStorage.getItem(
            `${process.env.VUE_APP_TOKEN_PREFIX}token`,
          )}`,
          'Content-Type': 'application/json',
          Accept: 'application/json',
        },
      })
        .then(response => {
          this.jobAds = response.data.data;
          this.totalPages = response.data.last_page;
          this.isLoading = false;
          if (localStorage.getItem('sKeyWords').length > 0) {
            localStorage.setItem('sKeyWords', []);
            localStorage.setItem('sLocation', []);
          }
        })
        .catch(() => {
          this.isLoading = false;
        });
    },
    flattenCompetences(competences) {
      const flattenedCompetences = [];
      competences.forEach(competence => {
        flattenedCompetences.push(competence.id);

        if (competence.children && competence.children.length > 0) {
          // Recursively flatten children and include their IDs
          const childrenIds = this.flattenCompetences(competence.children);
          flattenedCompetences.push(...childrenIds);
        }
      });

      return flattenedCompetences;
    },
  },
  computed: {
    ...mapGetters([
      'getNextPage',
      'getTotalPages',
      'getCurrentPage',
      'allSearchJobResults',
      'getEmployersDropdownCandidate',
      'getCompetencesFilterList',
    ]),
  },
  mounted() {
    this.retrieveCompetencesList();
    if (
      localStorage.getItem('sKeyWords') !== null &&
      localStorage.getItem('sKeyWords').length > 0
    ) {
      this.keywords = JSON.parse(localStorage.getItem('sKeyWords'));
    }
    if (localStorage.getItem('sLocation') != null && localStorage.getItem('sLocation').length > 0)
      this.sendLocation = JSON.parse(localStorage.getItem('sLocation'));
    this.searchJob(1);
  },
};
</script>
<style lang="scss" scoped>
@import './src/assets/scss/_variables.scss';

.mid-section {
  padding: 60px 0;
  background: hsl(23, 100%, 47%);
  color: #fff;
  margin-bottom: 40px;
  img {
    width: 56px;
    height: 65px;
    flex-shrink: 0;
    margin: 20px 20px 0 0;
  }
  h2 {
    text-align: center;
    text-transform: uppercase;
    margin-bottom: 30px;
  }
  p {
    text-align: center;
    font-family: $font-family-sans-lato;
    font-size: 18px;
  }
  .text-box {
    margin-top: 80px;
    width: 365px;
    position: relative;
    .text {
      h3 {
        text-transform: uppercase;
        font-size: 22px;
      }
      p {
        text-align: left;
        font-family: $font-family-sans-lato;
        font-size: 16px;
      }
    }
    span {
      position: absolute;
      display: inline-block;
      width: 40px;
      height: 40px;
      border-radius: 50%;
      line-height: 40px;
      background: #424242;
      color: #fff;
      text-decoration: none;
      text-align: center;
      top: 50%;
      right: -35px;
      transform: translate(0, -50%);
    }
  }
}

@media only screen and (max-width: 576px) {
  /* .latest-ads {
    .single {
      flex-wrap: wrap;
      img {
        display: none;
      }
      .job-info {
        width: 100%;
        margin-bottom: 12px;
      }
      .tagline {
        margin: 12px 0 0 0 !important;
        width: 100%;
        text-align: center;
      }
      .location {
        margin: 0;
        color: #666;
        width: 48%;
        text-align: left;
        i {
          display: none;
        }
        &:nth-last-of-type(3) {
          text-align: right;
        }
      }
    }
  } */
  .mid-section {
    .mobile-wrap {
      flex-wrap: wrap;
    }
    .text-box {
      width: 290px;
    }
  }
}

@media only screen and (max-width: 576px) {
  /* .latest-ads {
    .single {
      flex-wrap: wrap;
      img {
        display: none;
      }
      .job-info {
        width: 100%;
        margin-bottom: 12px;
      }
      .tagline {
        margin: 12px 0 0 0 !important;
        width: 100%;
        text-align: center;
      }
      .location {
        margin: 0;
        color: #666;
        width: 48%;
        text-align: left;
        i {
          display: none;
        }
        &:nth-last-of-type(3) {
          text-align: right;
        }
      }
    }
  } */
  .mid-section {
    .mobile-wrap {
      flex-wrap: wrap;
    }
    .text-box {
      width: 290px;
    }
  }
}

.container {
  max-width: 1320px;
}

.main-header {
  height: 70vh;
  background: url('../../../public/img/homepage/header-search-jobs.jpg');
  background-size: cover;
  margin-top: 69px;
  .new-control {
    background: #fff !important;
    min-height: 53.6px !important;
    margin-bottom: 14px;
    font-size: 16px !important;
    color: #777;
    font-family: Montserrat, Roboto, 'Helvetica Neue', Arial, sans-serif !important;
    padding-left: 21px !important;
  }
  .container {
    height: 70vh;
    flex-wrap: wrap;
    h1 {
      color: #fff;
      font-size: 2.5rem;
      width: 100%;
      span {
        display: block;
      }
    }
    .form-inline {
      width: 100%;
      .col-1-left {
        flex: 1;
        margin-right: 12px;
      }
      .col-2-middle {
        width: 40%;
      }
      .form-group {
        position: relative;
        width: 100%;
        display: block;
        i {
          position: absolute;
          top: 50%;
          transform: translate(0, -50%);
          right: 20px;
          color: #9b9b9b;
          font-size: 14px;
          opacity: 0.6;
        }
        .form-control {
          background: red;
          border-radius: 8px;
          min-height: 65px;
          flex: 1;
          font-size: 18px;
          width: 100%;
          font-family: $font-family-sans-lato;
        }
        .btn-secondary {
          height: 54px;
          border-radius: 8px;
          display: block;
          width: 100%;
          text-transform: uppercase;
          margin-bottom: 12px;
        }
      }
      a {
        display: block;
        color: #fff;
        text-decoration: none;
        font-size: 18px;
        margin-top: 10px;
      }
    }
  }
}

.latest-ads {
  padding: 60px 0;
  h2 {
    text-transform: uppercase;
    font-size: 21px;
    margin-bottom: 40px;
  }
  .single {
    padding: 5px;
    background: #fff;
    box-shadow: 0px 15px 35px #0000000d;
    margin-bottom: 20px;
    font-family: $font-family-sans-lato;
    img {
      width: 70px;
      height: 70px;
      object-fit: contain;
      object-position: center;
      overflow: hidden;
      margin-right: 12px;
      flex-shrink: 0;
    }
    .job-info {
      width: 37%;
      margin-right: 12px;
      a {
        display: block;
        text-decoration: none;
        &:first-of-type {
          font-size: 18px;
        }
        &:nth-of-type(2) {
          color: #424242;
          font-size: 16px;
        }
      }
    }
    .location {
      text-align: center;
      width: 130px;
      margin: 0 10px;
      a {
        text-decoration: none;
      }
      i {
        display: block;
        color: #afafaf;
        font-size: 18px;
        margin-bottom: 5px;
      }
      span {
        font-size: 12px;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        display: block;
        text-transform: uppercase;
      }
    }
    .tagline {
      text-align: right;
      width: 200px;
      a {
        display: inline-block;
        background: #f2f2f2;
        border-radius: 16px;
        color: #3e3e3e;
        border: 5px solid #fff;
        font-size: 13px;
        padding: 3px 8px;
        text-decoration: none;
        font-weight: 500;
      }
    }
  }
}
.pagination {
  a {
    color: #495057;
    font-size: 14px;
  }
}

@media only screen and (max-width: 992px) {
}

@media only screen and (max-width: 768px) {
  .main-header {
    height: auto;
    .container {
      height: auto;
      padding: 30px 20px;
      h1 {
        font-size: 2rem;
      }
      .col-1-left,
      .col-2-middle,
      .col-3-last {
        width: 100% !important;
        margin-right: 0;
      }
      .col-3-last {
        height: auto !important;
      }
      .form-inline {
        .form-group {
          width: 100% !important;
          margin: 12px 0px;
          &:first-of-type {
            width: 100%;
          }
          .form-control {
            min-height: 55px;
          }
          .btn-secondary {
            height: 55px;
          }
        }
      }
      a {
        width: 100%;
      }
    }
  }
}

@media only screen and (max-width: 576px) {
  .main-header {
    margin-top: 60px;
    .container {
      .form-inline {
        .col-1-left {
          margin-right: 0;
        }
      }
    }
  }
  .latest-ads {
    .single {
      flex-wrap: wrap;
      img {
        display: none;
      }
      .job-info {
        width: 100%;
        margin-bottom: 12px;
      }
      .tagline {
        margin: 12px 0 0 0 !important;
        width: 100%;
        text-align: center;
      }
      .location {
        margin: 0;
        color: #666;
        width: 48%;
        text-align: left;
        i {
          display: none;
        }
        &:nth-last-of-type(3) {
          text-align: right;
        }
      }
    }
  }
  .mid-section {
    .mobile-wrap {
      flex-wrap: wrap;
    }
    .text-box {
      width: 290px;
    }
  }
}
</style>
